import React, {useEffect, useState} from "react";

import Solutions from "../components/solutions/solutions/Solutions";
import {AppLayout} from "@amzn/awsui-components-react";
import HubNavigation from "../components/hubnavigation";
import {useSelector} from "react-redux";
import {RootState} from "../store";
import {notificationTypeEnum} from "../constants/Constants";
import Notification from "../components/common/Notification";

const SolutionsPage: React.FC = () => {

    const notificationType = useSelector((state: RootState) => state.notification.notificationType);
    const content = useSelector((state: RootState) => state.notification.content);
    const eventType = useSelector((state: RootState) => state.notification.eventType);

    const [showNotification, setShowNotification] = useState(false);

    useEffect(() => {
        if (notificationType === notificationTypeEnum.ADDSOLUTION || notificationType === notificationTypeEnum.DELETESOLUTION) {
            setShowNotification(true);
        }
    }, [notificationType, content, eventType])

    return (
        <div>
            <AppLayout
                contentType="cards"
                headerSelector="#h"
                content={<Solutions/>}
                navigation={<HubNavigation />}
                notifications={<Notification showNotification={showNotification} type={eventType} message={content}/>}
            />
        </div>
    )
}

export default SolutionsPage;